import { createSlice } from '@reduxjs/toolkit';
import PropertyModel from '../../pages/Murabaha/models/property.model';
import { TransactionSteps } from '../../pages/Murabaha/TransferSellWithdrawal/TransactionProgressBar';
import TransferUnitsDto from '../../pages/Murabaha/models/transfer_units.dto';

interface MurabahaState {
  properties: PropertyModel[];
  isPropertiesLoading: boolean;
  currentTransferStep: TransactionSteps;
  transferUnitsDto: TransferUnitsDto;
}

const initialState: MurabahaState = {
  properties: [],
  isPropertiesLoading: true,
  currentTransferStep: TransactionSteps.TRANSFER,
  transferUnitsDto: new TransferUnitsDto(),
};

const murabahaReducer = createSlice({
  name: 'murabaha',
  initialState,
  reducers: {
    setPropertiesToMurabahaState(state, action) {
      state.properties = action.payload;
      state.isPropertiesLoading = false;
    },

    /** Set the current transfer step */
    setCurrentTransferStepToState(
      state,
      { payload }: { payload: TransactionSteps }
    ) {
      state.currentTransferStep = payload;
    },

    /** Set the transfer units DTO to state */
    setTransferUnitsDtoToState(state, { payload }: { payload: TransferUnitsDto }) {
      state.transferUnitsDto = payload;
    },
  },
});

export const {
  setPropertiesToMurabahaState,
  setCurrentTransferStepToState,
  setTransferUnitsDtoToState,
} = murabahaReducer.actions;

export default murabahaReducer.reducer;
